

// footer-data.js
// Static footer text per language. Footer component should ONLY read from here.

const footerData = {
    en: {
        contactHeading: 'Contact Us',
        companyHeading: 'Company',
        areasHeading: 'Areas We Serve',
        ServicesHeading: 'Services',
        CategoriesHeading: 'Categories',
        ProjectsHeading: 'Projects',
        LocationsHeading: 'Locations',
        ProductsHeading: 'Products',
        aboutHeading: 'About Us',
        hoursHeading: 'Opening Hours',
        addressHeading: 'Address',
        productsHeading: 'Products',
        menuHeading: 'Menu',

        allProductsText: 'All Products',
        menuHome: 'Home',
        menuServices: 'Programs',
        menuContact: 'Contact Us',

        description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        ctaButton: 'Talk to us',

        // Dark brand panel (left side of the split footer), blurb under the name
        brandBlurb: 'Premium retractable screens for homes that are made to be lived in.',

        // Contact-column row labels (bold title shown above each value)
        callUsLabel: 'Call Us',
        emailUsLabel: 'Email Us',
        callNowLabel: 'Call Now',

        navigationHeading: 'Navigation',
        knowledgeHeading: 'Guides',
        eventsHeading: 'Events',
        seeAllEvents: 'See all events',

        // Contact block sub-labels (under each contact row)
        phoneHours: 'Mon Fri 8AM-6PM',
        emailNote: 'We reply within 1 business day',
        locationTitle: 'Serving Your Region',
        locationNote: 'On site & virtual consultations',

        // "Need help now?" CTA bar (replaces the old donate row)
        helpHeading: 'Need help now?',
        helpSubtext: 'Call us for a quick, no obligation conversation.',
        helpBtn: 'CALL',

        allRightsReserved: 'All rights reserved.',

        // COMPANY column
        companyLinks: [
            { label: 'About Us',      href: '/about' },
            { label: 'How We Help',   href: '/services' },
            { label: 'Our Process',   href: '/#process' },
            { label: 'Testimonials',  href: '/#testimonials' },
            { label: 'Guides',        href: '/blog' },
            { label: 'Contact',       href: '/contact' },
        ],

        // AREAS WE SERVE column
        areaLinks: [
            { label: 'City One',   href: '/contact' },
            { label: 'City Two',   href: '/contact' },
            { label: 'City Three', href: '/contact' },
            { label: 'Region',     href: '/contact' },
        ],
        areasAllLabel: 'View All Areas',
        areasAllHref: '/contact',

        navLinks: [
            { label: 'Home',      href: '/' },
            { label: 'Services',  href: '/services' },
            { label: 'Guides',    href: '/blog' },
            { label: 'About Us',  href: '/about' },
            { label: 'Contact',   href: '/contact' },
        ],

        shippingAndReturnsText: 'Shipping & Returns',
        refundPolicyText: 'Refund Policy',
        warrantyText: 'Warranty',
        privacyText: 'Privacy Policy',
        termsText: 'Terms & Conditions',
        paymentMethods: 'Secure Payment Methods',

        newsletterHeading: 'Stay in the loop',
        newsletterSubtext: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        newsletterPlaceholder: 'Your email address',
        newsletterBtn: 'Join',
        newsletterSuccess: "You're in! Thanks for joining.",
        newsletterSuccessSubtext: "We'll send useful content, no spam.",
        newsletterSuccessClose: "Got it",
        newsletterError: 'Something went wrong. Please try again.',

        communityLiveLabel: 'Live Community',
        communityHeading: 'Join the Community',
        communitySubtext: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        communityBtn: 'Join the Community',
        communityUrl: '/community/join',
    },

    he: {
        contactHeading: 'צור קשר',
        companyHeading: 'החברה',
        areasHeading: 'איזורי שירות',
        ServicesHeading: 'שירותים',
        CategoriesHeading: 'קטגוריות',
        ProjectsHeading: 'פרויקטים',
        LocationsHeading: 'איזורי שירות',
        ProductsHeading: 'מוצרים',
        aboutHeading: 'אודות',
        hoursHeading: 'שעות פעילות',
        addressHeading: 'כתובת',
        productsHeading: 'מוצרים',
        menuHeading: 'תפריט',

        allProductsText: 'כל המוצרים',
        menuHome: 'דף הבית',
        menuServices: 'תוכניות',
        menuContact: 'צור קשר',

        description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        ctaButton: 'דברו איתנו',

        // Dark brand panel (left side of the split footer), blurb under the name
        brandBlurb: 'רשתות נגללות איכותיות לבתים שנועדו לחיות בהם.',

        // Contact-column row labels (bold title shown above each value)
        callUsLabel: 'התקשרו אלינו',
        emailUsLabel: 'כתבו לנו',
        callNowLabel: 'התקשרו עכשיו',

        navigationHeading: 'ניווט',
        knowledgeHeading: 'מדריכים',
        eventsHeading: 'אירועים',
        seeAllEvents: 'לכל האירועים',

        phoneHours: 'א׳-ו׳ 8:00-18:00',
        emailNote: 'נחזור אליכם תוך יום עסקים אחד',
        locationTitle: 'Serving Your Region',
        locationNote: 'ייעוץ פרונטלי ומקוון',

        helpHeading: 'צריכים עזרה עכשיו?',
        helpSubtext: 'התקשרו לשיחה קצרה, ללא כל התחייבות.',
        helpBtn: 'חייגו',

        allRightsReserved: 'כל הזכויות שמורות.',

        companyLinks: [
            { label: 'אודות',        href: '/about' },
            { label: 'איך אנחנו עוזרים', href: '/services' },
            { label: 'התהליך שלנו',   href: '/#process' },
            { label: 'המלצות',        href: '/#testimonials' },
            { label: 'מדריכים',       href: '/blog' },
            { label: 'צור קשר',       href: '/contact' },
        ],

        areaLinks: [
            { label: 'City One',   href: '/contact' },
            { label: 'City Two',   href: '/contact' },
            { label: 'City Three', href: '/contact' },
            { label: 'Region',     href: '/contact' },
        ],
        areasAllLabel: 'לכל איזורי השירות',
        areasAllHref: '/contact',

        navLinks: [
            { label: 'דף הבית',   href: '/' },
            { label: 'שירותים',   href: '/services' },
            { label: 'מדריכים',   href: '/blog' },
            { label: 'קצת עלינו', href: '/about' },
            { label: 'צור קשר',   href: '/contact' },
        ],

        privacyText: 'מדיניות פרטיות',
        termsText: 'תנאים והגבלות',
        paymentMethods: 'שיטות תשלום בטוחות',

        newsletterHeading: 'הישארו מעודכנים',
        newsletterSubtext: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        newsletterPlaceholder: 'כתובת האימייל שלכם',
        newsletterBtn: 'הצטרפו',
        newsletterSuccess: 'נרשמתם! תודה.',
        newsletterSuccessSubtext: 'נשלח תוכן שימושי, ללא ספאם.',
        newsletterSuccessClose: 'הבנתי',
        newsletterError: 'משהו השתבש. נסה שוב.',

        communityLiveLabel: 'קהילה פעילה',
        communityHeading: 'הצטרפו לקהילה',
        communitySubtext: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        communityBtn: 'הצטרפו לקהילה',
        communityUrl: '/community/join',
    },
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getFooterData(language) {
    const lang = resolveLanguage(language);
    return footerData[lang] || footerData.en;
}

export default footerData;
